export const Chevron = ({ className }: { className?: string }) => (
  <svg viewBox="0 0 24 24" aria-hidden className={className}>
    <path d="M13.5902 12L8.99023 7.4L10.044 6.34625L15.6977 12L10.044 17.6538L8.99023 16.6L13.5902 12Z" />
  </svg>
);
